import { Injectable } from '@angular/core';

/**
 * The service that manages the storage of application data.
 *
 * The service uses `localStorage` by default.
 * If the Web Storage API is disabled or if the storage limit is reached, the in-memory storage is used.
 */
@Injectable({ providedIn: 'root' })
export class StorageManagerService {
  private items: Map<string, any> = new Map<string, any>();

  constructor() {}

  public store(key: string, value: string | object): boolean {
    const stringValue = JSON.stringify(value);
    this.items.set(key, stringValue);

    try {
      const storage: Storage = localStorage;
      storage.setItem(key, stringValue);
    } catch (error) {}

    return true;
  }

  public load(key: string): string | null {
    if (this.items.has(key)) {
      try {
        return JSON.parse(this.items.get(key));
      } catch (e) {
        this.delete(key);
        return null;
      }
    } else {
      try {
        const storage: Storage = localStorage;
        const data: string | null = storage ? storage.getItem(key) : null;
        if (data) {
          this.items.set(key, data);
          return JSON.parse(data);
        } else {
          return null;
        }
      } catch (error) {
        return null;
      }
    }
  }


  public loadFromLocalStorage(key: string): string | null {
    try {
      const storage: Storage = localStorage;
      const data: string | null = storage ? storage.getItem(key) : null;
      if (data) {
        return JSON.parse(data);
      } else {
        return null;
      }
    } catch (error) {
      return null;
    }
  }


  public delete(key: string): boolean {
    this.items.delete(key);

    try {
      const storage: Storage = localStorage;
      storage.removeItem(key);
    } catch (error) {}

    return true;
  }
}
